document.addEventListener('DOMContentLoaded', () => {
  new Swiper('.el-feature-slider__slider', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 16,
    watchOverflow: true,
    allowTouchMove: true,

    navigation: {
      nextEl: `.el-feature-slider__next`,
      prevEl: `.el-feature-slider__prev`,
    },

    on: {
      init: updateProgress,
      slideChange: updateProgress,
      progress: updateProgress,
    },
  });

  function updateProgress(swiper) {
    const fill = document.querySelector(".el-feature-slider__progress-fill");

    const current = swiper.realIndex + 1;
    const total = swiper.slides.length;

    const percent = (current / total) * 100;

    if (fill) {
      fill.style.width = `${percent}%`;
    }
  }
});